import { defineMessages } from 'react-intl';

export const harmonizationMessages = defineMessages({
  suggestWithAI: {
    description: 'Button text to trigger AI harmonization code generation',
    defaultMessage: 'Suggest with AI',
    id: 'E0VbtE',
  },
  aiSuggestedCodes: {
    description: 'Header for AI suggested harmonization codes section',
    defaultMessage: 'AI Suggested Harmonization Codes:',
    id: 'ZfraPt',
  },
  clear: {
    description: 'Link text to clear AI suggestions',
    defaultMessage: 'Clear',
    id: 'I0ElkA',
  },
  confidenceHigh: {
    description: 'Badge label for high confidence suggestions',
    defaultMessage: 'High Confidence',
    id: 'NmPVRt',
  },
  confidenceMedium: {
    description: 'Badge label for medium confidence suggestions',
    defaultMessage: 'Medium Confidence',
    id: 'xtpNZ2',
  },
  confidenceLow: {
    description: 'Badge label for low confidence suggestions',
    defaultMessage: 'Low Confidence',
    id: 'Sco4JS',
  },
  noSuggestionsAvailable: {
    description: 'Message when no suggestions are returned',
    defaultMessage: 'No suggestions available for this product',
    id: 'TTIADb',
  },
  newProductRequiresCustomsDescription: {
    description: 'Tooltip message explaining why suggest button is disabled for new products',
    defaultMessage:
      'Product descriptions help generate more accurate HS codes. Include materials, usage, and specific details for best results.',
    id: 'bKRo71',
  },
  errorTitle: {
    description: 'Title for harmonization error notification',
    defaultMessage: 'Error',
    id: 'FftasZ',
  },
  generateError: {
    description: 'Error message when harmonization code generation fails',
    defaultMessage: 'Failed to generate harmonization codes. Please try again later.',
    id: 'EGsf5y',
  },
});
